const EVENT_STATUS = Object.freeze({
  patchTest: 'patch_test',
  timeOff: 'time_off',
  noShow: 'no_show',
  confirmed: 'confirmed',
  arrived: 'arrived',
  finished: 'finished',
  canceled: 'canceled',
  deleted: 'deleted',
});

// noinspection JSUnusedGlobalSymbols
export default EVENT_STATUS;
